import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=6c05093a"
import script from "./QuestionPreview.vue?vue&type=script&lang=js"
export * from "./QuestionPreview.vue?vue&type=script&lang=js"
import style0 from "./QuestionPreview.vue?vue&type=style&index=0&id=6c05093a&prod&lang=scss"
import style1 from "./QuestionPreview.vue?vue&type=style&index=1&id=6c05093a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports